import { NEW_MESSAGE_ACTION_HANDLERS } from '../../chat/modules/new-message';
import { LOAD_MESSAGES_ACTION_HANDLERS } from '../../chat/modules/load-messages';
import { CHAT_ACTIONS_ACTION_HANDLERS } from '../../chat/modules/chat-actions';
import { LIGHTBOX_ACTION_HANDLERS } from '../../chat/modules/lightbox';
import { CHAT_BUTTON_ACTION_HANDLERS } from '../modules/chat-button';

const ACTION_HANDLERS = {
  ...CHAT_ACTIONS_ACTION_HANDLERS,
  ...NEW_MESSAGE_ACTION_HANDLERS,
  ...LOAD_MESSAGES_ACTION_HANDLERS,
  ...LIGHTBOX_ACTION_HANDLERS,
  ...CHAT_BUTTON_ACTION_HANDLERS,
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  currentUser: {},
  chat: {},
  customerId: null,
  chats: [{ 1: 1 }],
  messages: [],
  timestamp: new Date().getTime(),
  visible: false,
  unreadCount: 0,
};
export default function chatReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./app/javascript/customer_chat/store/chat-reducer.js